// extracted by mini-css-extract-plugin
module.exports = {"status":"StatusLegend_status__S8R1o","statusLegend":"StatusLegend_statusLegend__2WNSS"};